import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-6 px-4 sm:px-6 bg-cream" data-id="element-66" data-mp="1o3x1pk7r0m0y">
      <div className="max-w-2xl mx-auto bg-white border border-gold/40 p-4 sm:p-6 rounded-xl text-center shadow-sm" data-id="element-67" data-mp="1o3dnoel7yhs7">
        <p className="text-[11px] sm:text-sm font-heading font-bold text-petrol uppercase tracking-widest mb-2" data-id="element-68" data-mp="22128jmfadox9">
          Votre achat est entièrement protégé
        </p>
        <div className="w-12 h-12 mx-auto bg-sage/20 rounded-full flex items-center justify-center mb-2 border border-sage/40" data-id="element-69" data-mp="19fad0rw8ehx2">
          <ShieldCheckIcon className="w-6 h-6 text-petrol" data-id="element-70" data-mp="14dtgf8ks5hma" />
        </div>
        <h3 className="text-lg sm:text-2xl font-display text-navy mb-2 leading-none tracking-wide uppercase" data-id="element-71" data-mp="1j5vagc065gee">
          🛡️ Garantie satisfait ou remboursé pendant 7 jours
        </h3>
        <p className="text-[12.5px] sm:text-base text-ink leading-snug mb-1.5" data-id="element-72" data-mp="qmycmap51qpk">
          Essayez SENIOR FITNESS PRO™ pendant 7 jours. Découvrez les 6 modules,
          les 5 Bonus Premium et commencez immédiatement à utiliser les
          ressources avec vos groupes.
        </p>
        <p className="text-[12.5px] sm:text-base text-ink leading-snug" data-id="element-73" data-mp="txku73tfb803">
          Si vous n'êtes pas entièrement satisfait, contactez-nous dans les 7
          jours suivant votre achat et nous vous rembourserons 100 % de votre
          commande.{' '}
          <span className="font-bold text-navy" data-id="element-74" data-mp="12sr34bnzq66u">
            Aucun risque. Aucune justification.
          </span>
        </p>
      </div>
    </section>;
}